import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const names = {
  interestRateSetting: ItemName.of([Locale.ja, '利子率設定'], [Locale.en, 'Interest Rate Setting']),
  interestRateSettingImport: ItemName.of(
    [Locale.ja, '利子率設定取込'],
    [Locale.en, 'Interest Rate Setting Import'],
  ),
};

const interestRateSetting = {
  names,
};

export { interestRateSetting };
